export interface DataURLConversionResult<T> {
	mime: string | null
	content: T
}

export function saveAsFile(blob: Blob, name: string) {
	// Namespace is used to prevent conflict w/ Chrome Poper Blocker extension (Issue https://github.com/eligrey/FileSaver.js/issues/561)
	const a: HTMLAnchorElement = document.createElementNS('http://www.w3.org/1999/xhtml', 'a') as HTMLAnchorElement
	a.download = name
	a.rel = 'noopener'
	a.href = URL.createObjectURL(blob)

	setTimeout(() => URL.revokeObjectURL(a.href), 40 /* sec */ * 1000)
	setTimeout(() => a.click(), 0)
}

export function convertDataURLtoBlob(dataUrl: string): Blob {
	const conversion = convertDataURLtoUint8Array(dataUrl)
	return new Blob([conversion.content], { type: conversion.mime ?? undefined })
}

export function dataURLtoFile(dataUrl: string, filename: string): File {
	const { content, mime } = convertDataURLtoUint8Array(dataUrl)

	return new File([content], filename, { type: mime ?? undefined })
}

export function convertDataURLtoUint8Array(dataUrl: string): DataURLConversionResult<Uint8Array> {
	const arr = dataUrl.split(',')

	const mimeMatchArray = arr[0].match(/:(.*?);/)
	const mime = mimeMatchArray ? mimeMatchArray[1] : null

	const bstr = atob(arr[1])
	let n = bstr.length
	const u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}

	return { mime: mime, content: u8arr }
}
